import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Inject,
    Input, OnDestroy, OnInit,
    Output,
    Renderer2,
    ViewChild
} from '@angular/core';
import {Notification} from '@portals/api';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {DeviceDetectorService} from 'ngx-device-detector';
import {BaseComponent, ResponseService} from '@portals/core';
import {AuthState, ChannelsState} from '@portals/store';
import {tap} from 'rxjs';
import {environment} from '@portals/environments';
import {RESPONSE_TYPES, SCREENS} from "@portals/utils";
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'notification-preview',
    templateUrl: './notification-preview.component.html',
    styleUrls: ['./notification-preview.component.scss'],
})
export class NotificationPreviewComponent extends BaseComponent implements OnDestroy, OnInit {
    @Input() notification!: Notification;
    @Input() videoPoster: any;
    @Input() videoHeight!: number;
    @Input() webAppView = false;
    @Input() portalUser = true;
    @Input() showStatus = false;
    @Input() status = 'LIVE';
    @Input() color!: string;
    @Input() isAppJotto = environment.app == 'Jotto' || 'Jotto Web';
    @Output() drop: EventEmitter<any> = new EventEmitter<any>();
    @Output() mouseWatch: EventEmitter<boolean> = new EventEmitter<boolean>();
    currentLanguage = 'en';
    customLocalizationSet = false;
    @ViewChild('jottoPreview', {static: false}) jottoPreviewRef!: ElementRef;
    channelFollowers = 0;

    mouseInbound = false;

    @HostListener('mousemove', ['$event'])
    onMouseMove(event: MouseEvent) {
        this.mouseInbound = true;
        this.mouseWatch.emit(this.mouseInbound);
    }

    @HostListener('mouseenter')
    onMouseEnter() {
        this.mouseInbound = true;
        this.mouseWatch.emit(this.mouseInbound);
    }

    @HostListener('mouseleave')
    onMouseLeave() {
        this.mouseInbound = false;
        this.mouseWatch.emit(this.mouseInbound);
    }

    noVideoIcon = 'assets/images/no-video.png';
    betaUser = false;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public translate: TranslateService, private dialogRef: MatDialogRef<NotificationPreviewComponent>, private deviceService: DeviceDetectorService, public dialog: MatDialog, private renderer: Renderer2, private auth: AuthState, private responseService: ResponseService, private channel: ChannelsState) {
        super();
        this.betaUser = this.auth.data.role.type == 'beta_user';
        this.notification = this.data.notification;

// Localization stuff
        const systemDefaultLanguage = navigator.language.split('-')[0];
        const supportedLanguages = ['en', 'es', 'ar']; // Add more languages as needed
        const defaultLanguage = supportedLanguages.includes(systemDefaultLanguage) ? systemDefaultLanguage : 'en';
        translate.setDefaultLang(defaultLanguage);
        this.currentLanguage = systemDefaultLanguage;

        if (this.notification?.localization) {
            this.currentLanguage = this.notification.localization;
            this.customLocalizationSet = true;
            translate.setDefaultLang(this.notification.localization);
        }
    }

    videoResponse() {
        this.responseService.navigateTo(SCREENS.RESPONSE_SCREEN, {
            channel: this.responseService.currentPage?.parameters.channel,
            notification: this.notification,
            notificationType: this.notification.response_type ? this.notification.response_type : RESPONSE_TYPES.VIDEO
        })
    }

    ngOnDestroy() {
        this.videoUIRef?.nativeElement?.srcObject?.getTracks().forEach((track: any) => track.stop());
        super.ngOnDestroy();
    }

    ngOnInit() {
        if (this.notification?.channel?.uuid) {
            this.subscribe(
                this.channel.findOnebyUUID(<string>this.notification?.channel?.uuid).pipe(
                    tap((data) => {
                        this.channelFollowers = <number>data.num_followers;
                    })
                )
            );
        }
    }

    protected readonly localStorage = localStorage;
    protected readonly String = String;
}
